import { useEffect, useState } from "react";
import { Button } from "primereact/button";
// import { useNavigate } from "react-router";
import { LoadingBlock } from "../SharedComponents";
import { IHeaderSetters } from "../Journal";
import { Routes, Route, useParams, useNavigate } from "react-router";
import { RecapEntriesViewModel } from "../../../ViewModel/RecapEntriesViewModel";
import { TextAreaSection } from "../SharedComponents/ModifiableText/TextAreaSection.tsx/TextAreaSection";
import { CheckableTextGroup } from "../SharedComponents/ModifiableText/CompletableText/CheckableTextGroup";
import { GetCorrelation } from "../../../ViewModel/Utilities";
import { RecapStatus } from "../../../Services/DataService/Model/RecapEntry";
import { JournalViewModel } from "../../../ViewModel/JournalViewModel";
import { JournalStrings } from "../SharedComponents/JournalStrings";
import { appInsights } from "../../../Services/AppInsightsService";


export function RecapEntryPage({ headerSetters, journalViewModel }: { headerSetters: IHeaderSetters, journalViewModel: JournalViewModel }) {

    console.log("RecapEntryPage");
    return (
        <Routes>
            <Route path="/:recapId/*" element={<RecapEntryEdit journalViewModel={journalViewModel} headerSetters={headerSetters} />} />
        </Routes>
    )
}


export function RecapEntryEdit({ headerSetters }: { headerSetters: IHeaderSetters, journalViewModel: JournalViewModel }) {

    //
    // Setup all of our hooks
    //
    const navigate = useNavigate();
    const [viewModel, setViewModel] = useState<RecapEntriesViewModel | undefined>(undefined);
    const { recapId } = useParams();
    const [showSecondPage, setShowSecondPage] = useState(false);
    const [reviewText, setReviewText] = useState<string>('');
    const [disableNext, setDisableNext] = useState(true);
    const [disableComplete, setDisableComplete] = useState(true);

    const updateDisabled = () => {
        setDisableNext(!viewModel?.isHighlightsSelected);
        setDisableComplete(!viewModel?.isCompletable);
    }

    //
    // Set up our effects
    //
    useEffect(() => {
        (async () => {

            let myVM: RecapEntriesViewModel | null = null;
            if (recapId) {
                RecapEntriesViewModel.Manager.GetItemByKey(GetCorrelation(), recapId).then(
                    async (vm) => {
                        myVM = vm;
                        await vm?.Hydrate(GetCorrelation());
                        if (vm) {
                            setViewModel(vm);
                            setReviewText(vm.TypedData.entry);
                            setDisableNext(false);
                            vm.PropertyChanged.Subscribe(updateDisabled);
                        }
                    }
                );
            }
            else {
                var recaps = RecapEntriesViewModel.DisplayRecaps;

                (async () => {
                    if (recaps.length === 0)
                        throw new Error("No recaps found");

                    var vm = recaps[0];
                    myVM = vm;
                    await vm.Hydrate(GetCorrelation());
                    setViewModel(vm);
                    setReviewText(vm.TypedData.entry);
                    vm.PropertyChanged.Subscribe(updateDisabled);
                })();
            }

            updateDisabled();

            return () => {
                myVM?.PropertyChanged.Unsubscribe(updateDisabled);
            }
        })();
    }, [recapId]);


    useEffect(() => {
        viewModel?.SetEntryHeader(headerSetters);
    }, [headerSetters, viewModel]);

    //
    // Wait until weare done loading to show anything
    //
    if (!viewModel) {
        appInsights.trackTrace({ message: 'RecapEntryEditViewModelNotReady', properties: { reason: 'viewModel undefined', recapId: recapId } });
        return (<LoadingBlock />);
    }


    if (!showSecondPage)
        return (

            <div className='gl-recap-entry h-full w-full flex flex-column justify-content-between'>

                <div className="flex flex-column justify-content-center flex-grow-1 m-4">
                    <CheckableTextGroup
                        style="none"
                        title={JournalStrings.TutorialFlyout["gl-recap-top-magic-moments"].Title}
                        entries={viewModel.MagicMoments!}
                        className="gl-recap-top-magic-moments"
                        tutorialSteps={[
                            {
                                target: '.gl-recap-top-magic-moments',
                                content: (
                                    <>
                                        <p>{JournalStrings.TutorialFlyout["gl-recap-top-magic-moments"]["Content-0"]}</p>
                                        <p><strong>{JournalStrings.TutorialFlyout["gl-recap-top-magic-moments"]["Content-1-0"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-top-magic-moments"]["Content-1-1"]}</p>
                                        <p>{JournalStrings.TutorialFlyout["gl-recap-top-magic-moments"]["Content-2"]}</p>
                                    </>
                                ),
                                disableBeacon: true,
                                offset: 0
                            }

                        ]}
                    />
                    <CheckableTextGroup
                        style="none"
                        title={JournalStrings.TutorialFlyout["gl-recap-top-achievements"].Title}
                        entries={viewModel.TopAchievements!}
                        className="gl-recap-top-achievements"
                        tutorialSteps={[
                            {
                                target: '.gl-recap-top-achievements',
                                title: 'Select Your Top Achievements',
                                content: (
                                    <>
                                        <p>{JournalStrings.TutorialFlyout["gl-recap-top-achievements"]["Content-0"]}</p>
                                        <p><strong>{JournalStrings.TutorialFlyout["gl-recap-top-achievements"]["Content-1-0"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-top-achievements"]["Content-1-1"]}</p>
                                        <p>{JournalStrings.TutorialFlyout["gl-recap-top-achievements"]["Content-2-0"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-top-achievements"]["Content-2-1"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-top-achievements"]["Content-2-2"]}</p>
                                    </>
                                ),
                                disableBeacon: true,
                                offset: 0
                            }


                        ]}
                    />
                </div>


                <div className='flex flex-row justify-content-around flex-none'>

                    <Button
                        className='gl-continue-button gl-button-standard-typography'
                        label="Next"
                        icon="pi pi-caret-right"
                        iconPos="right"
                        disabled={disableNext}
                        onClick={() => {
                            setShowSecondPage(true);
                        }}
                    />
                </div>
            </div>
        );
    else
        return (
            <div className='h-full w-full flex flex-column justify-content-between'>


                <div className="flex-auto flex flex-column justify-content-center p-100">

                    <TextAreaSection
                        title={JournalStrings.TutorialFlyout["gl-recap-summarize-progress"].Title}
                        text={reviewText}
                        onChanged={(e) => {
                            setReviewText(e.target.value);
                            viewModel.TypedData.entry = e.target.value;
                        }}
                        className="gl-recap-summarize-progress"
                        tutorialSteps={[
                            {
                                target: '.gl-recap-summarize-progress',
                                content: (
                                    <>
                                        <p>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-0-0"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-0-1"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-0-2"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-0-3"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-0-4"]}</p>
                                        <p><strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-1-0"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-1-1"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-1-2"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-1-3"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-1-4"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-1-5"]}</p>
                                        <p>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-2-0"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-2-1"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-2-2"]}<strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-2-3"]}</strong>{JournalStrings.TutorialFlyout["gl-recap-summarize-progress"]["Content-2-4"]}</p>
                                    </>
                                ),
                                disableBeacon: true,
                                offset: 0
                            }

                        ]}
                    />
                    {
                        viewModel.SummaryReviews.length > 0 &&
                        <div>
                            <h3 className="gl-content-header-typography mb-0">{viewModel.SummariesReviewHeaderText}</h3>
                            {
                                viewModel.SummaryReviews.map((entry) =>
                                    <div key={entry.header} className="flex flex-column align-items-start justify-content-start mt-100 mb-100">
                                        <h4 className="gl-today-info-typography flex-none mr-100">{entry.header}</h4>
                                        <p className="gl-content-lowered-typography m-0">{entry.recap}</p>
                                    </div>
                                )
                            }
                        </div>
                    }
                </div>


                <div className='flex flex-row justify-content-around'>
                    <Button
                        className='gl-continue-button'
                        label="Previous"
                        icon="pi pi-caret-left"
                        iconPos="left"
                        onClick={() => {
                            setShowSecondPage(false);
                        }}
                    />

                    <Button
                        className='gl-continue-button'
                        label="Complete"
                        icon="pi pi-caret-right"
                        iconPos="right"
                        disabled={disableComplete}
                        onClick={() => {
                            viewModel.TypedData.status = RecapStatus.Complete;
                            navigate('/journal/home');
                        }}
                    />
                </div>
            </div>)
            ;
}